import React from "react";
import { LangContext } from "../../contexts/LangContext";
import en from "../../i18n/en";
import pl from "../../i18n/pl";

export function EmptyState({ onAdd }) {
  const { lang } = React.useContext(LangContext);
  const t = lang === "pl" ? pl : en;

  return (
    <div className="empty-state">
      <div className="empty-icon">🔍</div>
      <h3>{t.noTasks}</h3>
      <p>{t.noTasksDesc}</p>
      <button className="btn-add" onClick={onAdd}>
        {t.createFirstTask}
      </button>
    </div>
  );
}